import type { Role } from '@/data'
import api from '.'

export interface PaginatedRoles {
  data: Role[]
  meta: {
    current_page: number
    last_page: number
    per_page: number
    total: number
  }
}

export interface GetRolesParams {
  page?: number
  filters?: { key: string; value: string }[]
}

export async function getRoles(
  pageOrParams?: number | GetRolesParams, // roles still uses page[number] instead of page on BE
): Promise<PaginatedRoles> {
  const { page, filters } =
    typeof pageOrParams === 'number' || pageOrParams == null
      ? { page: pageOrParams as number | undefined, filters: undefined }
      : pageOrParams

  const filterParams: Record<string, string> = {}
  if (filters) {
    for (const f of filters) {
      filterParams[`filter[${f.key}]`] = f.value
    }
  }

  const res = await api.get('/', {
    params: {
      include: 'permissions',
      ...(page != null ? { page: { number: page } } : {}),
      ...filterParams,
    },
  })

  return {
    data: res.data.data,
    meta: res.data.meta,
  }
}
